import { BehaviorSubject } from 'rxjs';

export const epic$ = new BehaviorSubject<any>(() => null);

const injectedEpics = new Map<any, boolean>();

export function injectEpic(newEpic: any) {
  if (injectedEpics.has(newEpic)) return;

  epic$.next(newEpic);
  injectedEpics.set(newEpic, true);
}
